<template>
  <div class="calculator" :id="calculatorName">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-10 col-xl-8 mb-3">
          <div class="progress-container">
					<div class="progress-bar-bg">
						<div class="progress-bar-fill" :style="{ width: ((currentStep - 1) / (totalSteps - 1)) * 100 + '%' }"></div>
					</div>
				</div>

				<div class="step-nav-buttons mt-4 text-center">
					<button
						type="button"
						class="btn previous-step"
						@click="prevStep"
						v-if="currentStep != 1"
					>
						Back
					</button>
				</div>


				<div class="calculator-container">

					<div class="mt-3" @keyup="resetCalculation" @change="resetCalculation">

						<BooleanChoiceButtons
							fieldText="Are you purchasing or remortgaging?"
							buttonTextLeft="Purchasing"
							buttonTextRight="Remortgaging"	
							v-if="currentStep === 1"							
						>
							<template v-slot:left>
								<input type="radio" v-model="startOption" value="Purchasing" @click="clearRemortgagingValues">									
							</template>
							<template v-slot:right>
								<input type="radio" v-model="startOption" value="Remortgaging" @click="clearPurchasingValues">										
							</template>																
						</BooleanChoiceButtons>

						<BooleanChoiceButtons				
							fieldText="Do you have a property in mind?"
							buttonTextLeft="Yes"
							buttonTextRight="No"	
							v-if="currentStep === 2"								
						>
							<template v-slot:left>
								<input type="radio" v-model="propertyOption" value="Yes" @click="clearPurchaseValue">									
							</template>
							<template v-slot:right>
								<input type="radio" v-model="propertyOption" value="No" @click="clearPurchasePrice">									
							</template>																
						</BooleanChoiceButtons>

						<div v-if="currentStep === 3">
							<InputElement
								
								fieldText="What is the purchase price?"
							>
								<InputTypeNumber currencyPlaceholder v-model="purchasePrice"/>
							</InputElement>
						</div>

						<div v-if="currentStep === 4">
							<InputElement
								
								fieldText="Approximately, what value would you like to purchase at?"
							>
								<InputTypeNumber currencyPlaceholder v-model="purchaseValue"/>
							</InputElement>
						</div>

						<div v-if="currentStep === 5">
							<InputElement
								
								fieldText="What is your required mortgage amount?"
							>
								<InputTypeNumber currencyPlaceholder v-model="mortgageAmount"/>
							</InputElement>
						</div>

						<div v-if="currentStep === 6">
							<InputElement
								
								fieldText="What is the approximate value of your property?"
							>
								<InputTypeNumber currencyPlaceholder v-model="approximateValue"/>
							</InputElement>
						</div>

						<div v-if="currentStep === 7">
							<InputElement
								
								fieldText="What is your current outstanding mortgage amount?"
							>
								<InputTypeNumber currencyPlaceholder v-model="outstandingMortgage"/>
							</InputElement>
						</div>

						<div v-if="currentStep === 8">
							<InputElement
                  
								fieldText="Who is your current lender?"
							>
								<input id="currentLender" class="form-control calc-form-control" type="text" v-model="currentLender">
							</InputElement>
						</div>

						<BooleanChoiceButtons
							v-show="approximateValue > 0 && outstandingMortgage && currentLender"
							fieldText="Are you remortgaging with additional borrowing?"
							buttonTextLeft="Yes"
							buttonTextRight="No"	
							v-if="currentStep === 9"						
						>
							<template v-slot:left>
								<input type="radio" v-model="additionalBorrowing" value="Yes">								
							</template>
							<template v-slot:right>
								<input type="radio" v-model="additionalBorrowing" value="No">									
							</template>																
						</BooleanChoiceButtons>

						<div v-if="currentStep === 10">
							<InputElement
								
								fieldText="How much more would you like to borrow?"
							>
								<InputTypeNumber currencyPlaceholder v-model="additionalBorrowAmount"/>
							</InputElement>
						</div>

						<BooleanChoiceButtons
							fieldText="Number of applicants*"
							buttonTextLeft="1"
							buttonTextRight="2"	
							v-if="currentStep === 11"								
						>
							<template v-slot:left>
								<input type="radio" v-model="applicantsCount" value=1 @click="clearApplicant2">								
							</template>
							<template v-slot:right>
								<input type="radio" v-model="applicantsCount" value=2 >									
							</template>																
						</BooleanChoiceButtons>

						<div class="row mb-5" v-if="currentStep === 12">
							<div class="col-12 booleanLabel">First Applicant Employment status</div>
							<div class="col-12 row calc-right-buttons-wrapper">
								<MultiplyChoiceButton
									buttonText="Sole Trader"
								>
								<input type="radio" v-model="applicantEmployment1" value="sole-trader">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="Partnership"
								>
								<input type="radio" v-model="applicantEmployment1" value="partnership">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="Director with shareholding"
								>
								<input type="radio" v-model="applicantEmployment1" value="director-with-shareholding">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="Contractor"
								>
								<input type="radio" v-model="applicantEmployment1" value="contractor">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="CIS worker"
								>
								<input type="radio" v-model="applicantEmployment1" value="cis-worker">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="Employed"
								>
								<input type="radio" v-model="applicantEmployment1" value="employed">
								</MultiplyChoiceButton>
							</div>
						</div>
								
						<div class="row mb-5" v-if="currentStep === 13">
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<div class="col-12 booleanLabel">How long have you been trading?</div>
							<div class="col-12 row calc-right-buttons-wrapper">
								<MultiplyChoiceButton
									buttonText="0 years"
								>
								<input type="radio" v-model="soleTraderYearsTrading1" value="0">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="1 year"
								>
								<input type="radio" v-model="soleTraderYearsTrading1" value="1">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="2 years"
								>
								<input type="radio" v-model="soleTraderYearsTrading1" value="2">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="3+ years"
								>
								<input type="radio" v-model="soleTraderYearsTrading1" value="3plus">
								</MultiplyChoiceButton>
							</div>
						</div>

						<div v-if="currentStep === 14">
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<BooleanChoiceButtons
								fieldText="Do you have an accountant?"
								buttonTextLeft="Yes"
								buttonTextRight="No"	
															
							>
								<template v-slot:left>
									<input type="radio" v-model="soleTraderAccoutantOption1" value="Yes">							
								</template>
								<template v-slot:right>
									<input type="radio" v-model="soleTraderAccoutantOption1" value="No">							
								</template>																
							</BooleanChoiceButtons>
						</div>

						<div v-if="currentStep === 15"		>
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Are your tax returns up-to-date?"
							buttonTextLeft="Yes"
							buttonTextRight="No"	
													
						>
							<template v-slot:left>
								<input type="radio" v-model="soleTraderTaxReturns1" value="Yes">						
							</template>
							<template v-slot:right>
								<input type="radio" v-model="soleTraderTaxReturns1" value="No">							
							</template>																
						</BooleanChoiceButtons>
						</div>

						<div v-if="currentStep === 16"		>
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Has there been a substantial change in net profit in the last 2 years?"
							buttonTextLeft="Yes"
							buttonTextRight="No"	
																
						>
							<template v-slot:left>
								<input type="radio" v-model="soleTraderprofitChange1" value="Yes">						
							</template>
							<template v-slot:right>
								<input type="radio" v-model="soleTraderprofitChange1" value="No">							
							</template>																
						</BooleanChoiceButtons>
						</div>

								

						<div v-if="currentStep === 17">
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<InputElement
								
								fieldText="Your latest years net profit"
							>
								<InputTypeNumber currencyPlaceholder v-model="soleTraderLatestProfit1"/>
							</InputElement>
						</div>

						<div class="row mb-5" v-if="currentStep === 18">
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<div class="col-12 booleanLabel">How long have you been trading?</div>
							<div class="col-12 row calc-right-buttons-wrapper">
								<MultiplyChoiceButton
									buttonText="0 years"
								>
								<input type="radio" v-model="partnershipYearsTrading1" value="0">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="1 year"
								>
								<input type="radio" v-model="partnershipYearsTrading1" value="1">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="2 years"
								>
								<input type="radio" v-model="partnershipYearsTrading1" value="2">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="3+ years"
								>
								<input type="radio" v-model="partnershipYearsTrading1" value="3plus">
								</MultiplyChoiceButton>
							</div>
						</div>

						<div v-if="currentStep === 19">
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Do you have an accountant?"
							buttonTextLeft="Yes"
							buttonTextRight="No"
															
						>
							<template v-slot:left>
								<input type="radio" v-model="partnershipAccoutantOption1" value="Yes">							
							</template>
							<template v-slot:right>
								<input type="radio" v-model="partnershipAccoutantOption1" value="No">							
							</template>																
						</BooleanChoiceButtons>
						</div>

						<div v-if="currentStep === 20"	>
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Are your tax returns up-to-date?"
							buttonTextLeft="Yes"
							buttonTextRight="No"
														
						>
							<template v-slot:left>
								<input type="radio" v-model="partnershipTaxReturns1" value="Yes">						
							</template>
							<template v-slot:right>
								<input type="radio" v-model="partnershipTaxReturns1" value="No">							
							</template>																
						</BooleanChoiceButtons>
						</div>

						<div v-if="currentStep === 21"	>
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Has there been a substantial change in net profit in the last 2 years?"
							buttonTextLeft="Yes"
							buttonTextRight="No"	
																
						>
							<template v-slot:left>
								<input type="radio" v-model="partnershipProfitChange1" value="Yes">						
							</template>
							<template v-slot:right>
								<input type="radio" v-model="partnershipProfitChange1" value="No">							
							</template>																
						</BooleanChoiceButtons>
						</div>

						

						<div v-if="currentStep === 22">
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<InputElement
								
								fieldText="What percentage shareholding do you have?"
							>
								<InputTypeNumber v-model="partnershipShareholdPercentage1"/>
							</InputElement>
						</div>

						<div v-if="currentStep === 23">
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<InputElement
								
								fieldText="What is your share of the latest years net profit?"
							>
								<InputTypeNumber currencyPlaceholder v-model="partnershipShareholdProfit1"/>
							</InputElement>
						</div>

						<div class="row mb-5" v-if="currentStep === 24">
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<div class="col-12 booleanLabel">How long have you been a shareholding Director?</div>
							<div class="col-12 row calc-right-buttons-wrapper">
								<MultiplyChoiceButton
									buttonText="0 years"
								>
								<input type="radio" v-model="directorYearsTrading1" value="0">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="1 year"
								>
								<input type="radio" v-model="directorYearsTrading1" value="1">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="2 years"
								>
								<input type="radio" v-model="directorYearsTrading1" value="2">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="3+ years"
								>
								<input type="radio" v-model="directorYearsTrading1" value="3plus">
								</MultiplyChoiceButton>
							</div>
						</div>

						<div v-if="currentStep === 25"	>
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Do you have an accountant?"
							buttonTextLeft="Yes"
							buttonTextRight="No"
															
						>
							<template v-slot:left>
								<input type="radio" v-model="directorAccoutantOption1" value="Yes">							
							</template>
							<template v-slot:right>
								<input type="radio" v-model="directorAccoutantOption1" value="No">							
							</template>																
						</BooleanChoiceButtons>
						</div>

						<div v-if="currentStep === 26"		>
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Are your tax returns up-to-date?"
							buttonTextLeft="Yes"
							buttonTextRight="No"
																
						>
							<template v-slot:left>
								<input type="radio" v-model="directorTaxReturns1" value="Yes">						
							</template>
							<template v-slot:right>
								<input type="radio" v-model="directorTaxReturns1" value="No">							
							</template>																
						</BooleanChoiceButtons>
						</div>

						<div v-if="currentStep === 27"		>
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Have you recently changed trading style?"
							buttonTextLeft="Yes"
							buttonTextRight="No"	
															
						>
							<template v-slot:left>
								<input type="radio" v-model="directorTradingStyle1" value="Yes">				
							</template>
							<template v-slot:right>
								<input type="radio" v-model="directorTradingStyle1" value="No">					
							</template>																
						</BooleanChoiceButtons>
						</div>

						

						<div v-if="currentStep === 28">
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<InputElement
								
								fieldText="Your salary drawn"
							>
								<InputTypeNumber currencyPlaceholder v-model="directorSalaryDrawn1"/>
							</InputElement>
						</div>

						<div v-if="currentStep === 29">
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<InputElement
								
								fieldText="Dividends for the last 12 months"
							>
								<InputTypeNumber currencyPlaceholder v-model="directorYearDividends1"/>
							</InputElement>
						</div>

						<div v-if="currentStep === 30"		>
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Have you been contracting for at least 6 months?"
							buttonTextLeft="Yes"
							buttonTextRight="No"
															
						>
							<template v-slot:left>
								<input type="radio" v-model="contractorMonths1" value="Yes">								
							</template>
							<template v-slot:right>
								<input type="radio" v-model="contractorMonths1" value="No">									
							</template>																
						</BooleanChoiceButtons>
						</div>

						

						<div class="row mb-5" v-if="currentStep === 31">
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<div class="col-12 booleanLabel">If so, how long for?</div>
							<div class="col-12 row calc-right-buttons-wrapper">
								<MultiplyChoiceButton
									buttonText="0 years"
								>
								<input type="radio" v-model="contractorYearsTrading1" value="0">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="1 year"
								>
								<input type="radio" v-model="contractorYearsTrading1" value="1">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="2 years"
								>
								<input type="radio" v-model="contractorYearsTrading1" value="2">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="3+ years"
								>
								<input type="radio" v-model="contractorYearsTrading1" value="3plus">
								</MultiplyChoiceButton>
							</div>
						</div>

						<div v-if="currentStep === 32"			>
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Do you have an accountant?"
							buttonTextLeft="Yes"
							buttonTextRight="No"
														
						>
							<template v-slot:left>
								<input type="radio" v-model="contractorAccountantOption1" value="Yes">							
							</template>
							<template v-slot:right>
								<input type="radio" v-model="contractorAccountantOption1" value="No">							
							</template>																
						</BooleanChoiceButtons>
						</div>

						<div v-if="currentStep === 33"			>
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Are your tax returns up-to-date?"
							buttonTextLeft="Yes"
							buttonTextRight="No"	
														
						>
							<template v-slot:left>
								<input type="radio" v-model="contractorTaxReturns1" value="Yes">						
							</template>
							<template v-slot:right>
								<input type="radio" v-model="contractorTaxReturns1" value="No">							
							</template>																
						</BooleanChoiceButtons>
						</div>

						

						<div v-if="currentStep === 34">
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<InputElement
								
								fieldText="What is your daily rate?"
							>
								<InputTypeNumber currencyPlaceholder v-model="contractorDailyRate1"/>
							</InputElement>
						</div>

						<div v-if="currentStep === 35"				>
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Have you been sub-contracting for at least 12 months?"
							buttonTextLeft="Yes"
							buttonTextRight="No"	
													
						>
							<template v-slot:left>
								<input type="radio" v-model="subcontractorMonths1" value="Yes">								
							</template>
							<template v-slot:right>
								<input type="radio" v-model="subcontractorMonths1" value="No">								
							</template>																
						</BooleanChoiceButtons>
						</div>

						

						<div class="row mb-5" v-if="currentStep === 36">
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<div class="col-12 booleanLabel">If so, how long for?</div>
							<div class="col-12 row calc-right-buttons-wrapper">
								<MultiplyChoiceButton
									buttonText="0 years"
								>
								<input type="radio" v-model="subcontractorYearsTrading1" value="0">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="1 year"
								>
								<input type="radio" v-model="subcontractorYearsTrading1" value="1">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="2 years"
								>
								<input type="radio" v-model="subcontractorYearsTrading1" value="2">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="3+ years"
								>
								<input type="radio" v-model="subcontractorYearsTrading1" value="3plus">
								</MultiplyChoiceButton>
							</div>
						</div>

						<div v-if="currentStep === 37"				>
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Have you worked for the same contractor for 12 months?"
							buttonTextLeft="Yes"
							buttonTextRight="No"
															
						>
							<template v-slot:left>
								<input type="radio" v-model="subcontractorSameContractor1" value="Yes">						
							</template>
							<template v-slot:right>
								<input type="radio" v-model="subcontractorSameContractor1" value="No">							
							</template>																
						</BooleanChoiceButtons>
						</div>

						<div v-if="currentStep === 38"				>
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Does the company you work for arrange the payment of your tax?"
							buttonTextLeft="Yes"
							buttonTextRight="No"
																
						>
							<template v-slot:left>
								<input type="radio" v-model="subcontractorPaymentOfTax1" value="Yes">						
							</template>
							<template v-slot:right>
								<input type="radio" v-model="subcontractorPaymentOfTax1" value="No">							
							</template>																
						</BooleanChoiceButtons>
						</div>

						

						<div v-if="currentStep === 39">
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<InputElement
								
								fieldText="What is your annual income?"
							>
								<InputTypeNumber currencyPlaceholder v-model="subcontractorAnnualIcome1"/>
							</InputElement>
						</div>

						<div v-if="currentStep === 40">
							<h4 class="calc-fieldset-title">First Applicant Details</h4>
							<InputElement
								
								fieldText="What is your annual income?"
							>
								<InputTypeNumber currencyPlaceholder v-model="employedAnnualIncome1"/>
							</InputElement>
						</div>

						<div class="row mb-5" v-if="currentStep === 41">
							<div class="col-12 booleanLabel">Second Applicant Employment status</div>
							<div class="col-12 row calc-right-buttons-wrapper">
								<MultiplyChoiceButton
									buttonText="Sole Trader"
								>
								<input type="radio" v-model="applicantEmployment2" value="sole-trader">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="Partnership"
								>
								<input type="radio" v-model="applicantEmployment2" value="partnership">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="Director with shareholding"
								>
								<input type="radio" v-model="applicantEmployment2" value="director-with-shareholding">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="Contractor"
								>
								<input type="radio" v-model="applicantEmployment2" value="contractor">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="CIS worker"
								>
								<input type="radio" v-model="applicantEmployment2" value="cis-worker">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="Employed"
								>
								<input type="radio" v-model="applicantEmployment2" value="employed">
								</MultiplyChoiceButton>
							</div>
						</div>
								
						<div class="row mb-5" v-if="currentStep === 42">
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<div class="col-12 booleanLabel">How long have you been trading?</div>
							<div class="col-12 row calc-right-buttons-wrapper">
								<MultiplyChoiceButton
									buttonText="0 years"
								>
								<input type="radio" v-model="soleTraderYearsTrading2" value="0">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="1 year"
								>
								<input type="radio" v-model="soleTraderYearsTrading2" value="1">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="2 years"
								>
								<input type="radio" v-model="soleTraderYearsTrading2" value="2">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="3+ years"
								>
								<input type="radio" v-model="soleTraderYearsTrading2" value="3plus">
								</MultiplyChoiceButton>
							</div>
						</div>

						<div v-if="currentStep === 43"				>
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Do you have an accountant?"
							buttonTextLeft="Yes"
							buttonTextRight="No"	
														
						>
							<template v-slot:left>
								<input type="radio" v-model="soleTraderAccoutantOption2" value="Yes">							
							</template>
							<template v-slot:right>
								<input type="radio" v-model="soleTraderAccoutantOption2" value="No">							
							</template>																
						</BooleanChoiceButtons>
						</div>

						<div v-if="currentStep === 44"			>
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Are your tax returns up-to-date?"
							buttonTextLeft="Yes"
							buttonTextRight="No"	
														
						>
							<template v-slot:left>
								<input type="radio" v-model="soleTraderTaxReturns2" value="Yes">						
							</template>
							<template v-slot:right>
								<input type="radio" v-model="soleTraderTaxReturns2" value="No">							
							</template>																
						</BooleanChoiceButtons>
						</div>

						<div v-if="currentStep === 45"		>
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Has there been a substantial change in net profit in the last 2 years?"
							buttonTextLeft="Yes"
							buttonTextRight="No"	
																
						>
							<template v-slot:left>
								<input type="radio" v-model="soleTraderprofitChange2" value="Yes">						
							</template>
							<template v-slot:right>
								<input type="radio" v-model="soleTraderprofitChange2" value="No">							
							</template>																
						</BooleanChoiceButtons>
						</div>

						

						<div v-if="currentStep === 46">
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<InputElement
								
								fieldText="Your latest years net profit"
							>
								<InputTypeNumber currencyPlaceholder v-model="soleTraderLatestProfit2"/>
							</InputElement>
						</div>

						<div class="row mb-5" v-if="currentStep === 47">
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<div class="col-12 booleanLabel">How long have you been trading?</div>
							<div class="col-12 row calc-right-buttons-wrapper">
								<MultiplyChoiceButton
									buttonText="0 years"
								>
								<input type="radio" v-model="partnershipYearsTrading2" value="0">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="1 year"
								>
								<input type="radio" v-model="partnershipYearsTrading2" value="1">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="2 years"
								>
								<input type="radio" v-model="partnershipYearsTrading2" value="2">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="3+ years"
								>
								<input type="radio" v-model="partnershipYearsTrading2" value="3plus">
								</MultiplyChoiceButton>
							</div>
						</div>

						<div v-if="currentStep === 48"		>
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Do you have an accountant?"
							buttonTextLeft="Yes"
							buttonTextRight="No"
															
						>
							<template v-slot:left>
								<input type="radio" v-model="partnershipAccoutantOption2" value="Yes">							
							</template>
							<template v-slot:right>
								<input type="radio" v-model="partnershipAccoutantOption2" value="No">							
							</template>																
						</BooleanChoiceButtons>
						</div>

						<div v-if="currentStep === 49"	>
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Are your tax returns up-to-date?"
							buttonTextLeft="Yes"
							buttonTextRight="No"
														
						>
							<template v-slot:left>
								<input type="radio" v-model="partnershipTaxReturns2" value="Yes">						
							</template>
							<template v-slot:right>
								<input type="radio" v-model="partnershipTaxReturns2" value="No">							
							</template>																
						</BooleanChoiceButtons>
						</div>

						<div v-if="currentStep === 50"	>
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Has there been a substantial change in net profit in the last 2 years?"
							buttonTextLeft="Yes"
							buttonTextRight="No"	
																
						>
							<template v-slot:left>
								<input type="radio" v-model="partnershipProfitChange2" value="Yes">						
							</template>
							<template v-slot:right>
								<input type="radio" v-model="partnershipProfitChange2" value="No">							
							</template>																
						</BooleanChoiceButtons>
						</div>

						

						<div v-if="currentStep === 51">
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<InputElement
								
								fieldText="What percentage shareholding do you have?"
							>
								<InputTypeNumber v-model="partnershipShareholdPercentage2"/>
							</InputElement>
						</div>

						<div v-if="currentStep === 52">
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<InputElement
								
								fieldText="What is your share of the latest years net profit?"
							>
								<InputTypeNumber currencyPlaceholder v-model="partnershipShareholdProfit2"/>
							</InputElement>
						</div>

						<div class="row mb-5" v-if="currentStep === 53">
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<div class="col-12 booleanLabel">How long have you been a shareholding Director?</div>
							<div class="col-12 row calc-right-buttons-wrapper">
								<MultiplyChoiceButton
									buttonText="0 years"
								>
								<input type="radio" v-model="directorYearsTrading2" value="0">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="1 year"
								>
								<input type="radio" v-model="directorYearsTrading2" value="1">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="2 years"
								>
								<input type="radio" v-model="directorYearsTrading2" value="2">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="3+ years"
								>
								<input type="radio" v-model="directorYearsTrading2" value="3plus">
								</MultiplyChoiceButton>
							</div>
						</div>

						<div v-if="currentStep === 54"		>
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Do you have an accountant?"
							buttonTextLeft="Yes"
							buttonTextRight="No"
														
						>
							<template v-slot:left>
								<input type="radio" v-model="directorAccoutantOption2" value="Yes">							
							</template>
							<template v-slot:right>
								<input type="radio" v-model="directorAccoutantOption2" value="No">							
							</template>																
						</BooleanChoiceButtons>
						</div>

						<div v-if="currentStep === 55"		>
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Are your tax returns up-to-date?"
							buttonTextLeft="Yes"
							buttonTextRight="No"
																	
						>
							<template v-slot:left>
								<input type="radio" v-model="directorTaxReturns2" value="Yes">						
							</template>
							<template v-slot:right>
								<input type="radio" v-model="directorTaxReturns2" value="No">							
							</template>																
						</BooleanChoiceButtons>
						</div>

						<div v-if="currentStep === 56"		>
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Have you recently changed trading style?"
							buttonTextLeft="Yes"
							buttonTextRight="No"	
															
						>
							<template v-slot:left>
								<input type="radio" v-model="directorTradingStyle2" value="Yes">				
							</template>
							<template v-slot:right>
								<input type="radio" v-model="directorTradingStyle2" value="No">					
							</template>																
						</BooleanChoiceButtons>
						</div>

						

						<div v-if="currentStep === 57">
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<InputElement
								
								fieldText="Your salary drawn"
							>
								<InputTypeNumber currencyPlaceholder v-model="directorSalaryDrawn2"/>
							</InputElement>
						</div>

						<div v-if="currentStep === 58">
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<InputElement
								
								fieldText="Dividends for the last 12 months"
							>
								<InputTypeNumber currencyPlaceholder v-model="directorYearDividends2"/>
							</InputElement>
						</div>

						<div v-if="currentStep === 59"		>
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Have you been contracting for at least 6 months?"
							buttonTextLeft="Yes"
							buttonTextRight="No"
															
						>
							<template v-slot:left>
								<input type="radio" v-model="contractorMonths2" value="Yes">								
							</template>
							<template v-slot:right>
								<input type="radio" v-model="contractorMonths2" value="No">									
							</template>																
						</BooleanChoiceButtons>
						</div>

						

						<div class="row mb-5" v-if="currentStep === 60">
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<div class="col-12 booleanLabel">If so, how long for?</div>
							<div class="col-12 row calc-right-buttons-wrapper">
								<MultiplyChoiceButton
									buttonText="0 years"
								>
								<input type="radio" v-model="contractorYearsTrading2" value="0">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="1 year"
								>
								<input type="radio" v-model="contractorYearsTrading2" value="1">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="2 years"
								>
								<input type="radio" v-model="contractorYearsTrading2" value="2">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="3+ years"
								>
								<input type="radio" v-model="contractorYearsTrading2" value="3plus">
								</MultiplyChoiceButton>
							</div>
						</div>

						<div v-if="currentStep === 61"				>
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Do you have an accountant?"
							buttonTextLeft="Yes"
							buttonTextRight="No"
													
						>
							<template v-slot:left>
								<input type="radio" v-model="contractorAccountantOption2" value="Yes">							
							</template>
							<template v-slot:right>
								<input type="radio" v-model="contractorAccountantOption2" value="No">							
							</template>																
						</BooleanChoiceButtons>
						</div>

						<div v-if="currentStep === 62"				>
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Are your tax returns up-to-date?"
							buttonTextLeft="Yes"
							buttonTextRight="No"	
														
						>
							<template v-slot:left>
								<input type="radio" v-model="contractorTaxReturns2" value="Yes">						
							</template>
							<template v-slot:right>
								<input type="radio" v-model="contractorTaxReturns2" value="No">							
							</template>																
						</BooleanChoiceButtons>
						</div>

						

						<div v-if="currentStep === 63">
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<InputElement
								
								fieldText="What is your daily rate?"
							>
								<InputTypeNumber currencyPlaceholder v-model="contractorDailyRate2"/>
							</InputElement>
						</div>

						<div v-if="currentStep === 64"				>
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Have you been sub-contracting for at least 12 months?"
							buttonTextLeft="Yes"
							buttonTextRight="No"	
														
						>
							<template v-slot:left>
								<input type="radio" v-model="subcontractorMonths2" value="Yes">								
							</template>
							<template v-slot:right>
								<input type="radio" v-model="subcontractorMonths2" value="No">								
							</template>																
						</BooleanChoiceButtons>
						</div>

						

						<div class="row mb-5" v-if="currentStep === 65">
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<div class="col-12 booleanLabel">If so, how long for?</div>
							<div class="col-12 row calc-right-buttons-wrapper">
								<MultiplyChoiceButton
									buttonText="0 years"
								>
								<input type="radio" v-model="subcontractorYearsTrading2" value="0">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="1 year"
								>
								<input type="radio" v-model="subcontractorYearsTrading2" value="1">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="2 years"
								>
								<input type="radio" v-model="subcontractorYearsTrading2" value="2">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="3+ years"
								>
								<input type="radio" v-model="subcontractorYearsTrading2" value="3plus">
								</MultiplyChoiceButton>
							</div>
						</div>

						<div v-if="currentStep === 66"				>
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Have you worked for the same contractor for 12 months?"
							buttonTextLeft="Yes"
							buttonTextRight="No"
															
						>
							<template v-slot:left>
								<input type="radio" v-model="subcontractorSameContractor2" value="Yes">						
							</template>
							<template v-slot:right>
								<input type="radio" v-model="subcontractorSameContractor2" value="No">							
							</template>																
						</BooleanChoiceButtons>
						</div>

						<div v-if="currentStep === 67"				>
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<BooleanChoiceButtons
							fieldText="Does the company you work for arrange the payment of your tax?"
							buttonTextLeft="Yes"
							buttonTextRight="No"
																
						>
							<template v-slot:left>
								<input type="radio" v-model="subcontractorPaymentOfTax2" value="Yes">						
							</template>
							<template v-slot:right>
								<input type="radio" v-model="subcontractorPaymentOfTax2" value="No">							
							</template>																
						</BooleanChoiceButtons>
						</div>

						

						<div v-if="currentStep === 68">
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<InputElement
								
								fieldText="What is your annual income?"
							>
								<InputTypeNumber currencyPlaceholder v-model="subcontractorAnnualIcome2"/>
							</InputElement>
						</div>

						<div v-if="currentStep === 69">
							<h4 class="calc-fieldset-title">Second Applicant Details</h4>
							<InputElement
								
								fieldText="What is your annual income?"
							>
								<InputTypeNumber currencyPlaceholder v-model="employedAnnualIncome2"/>
							</InputElement>
						</div>

						<div class="row mb-5" v-if="currentStep === 70">
						<div class="col-12 booleanLabel">Why are you using the calculator today?</div>
						<div class="col-12 row calc-right-buttons-wrapper">
							<MultiplyChoiceButton
								buttonText="I’m ready to get a mortgage"
							>
							<input type="radio" v-model="calcReason1" value="I’m ready to get a mortgage">
							</MultiplyChoiceButton>
							<MultiplyChoiceButton
								buttonText="I’m curious to know what I can borrow"
							>
							<input type="radio" v-model="calcReason1" value="I’m curious to know what I can borrow">
							</MultiplyChoiceButton>
							<MultiplyChoiceButton
								buttonText="I want to understand what I can afford before I search for a home"
							>
							<input type="radio" v-model="calcReason1" value="I want to understand what I can afford before I search for a home">
							</MultiplyChoiceButton>
							</div>
						</div>

						<div class="row mb-5" v-if="currentStep === 71">
						<div class="col-12 booleanLabel">When are you hoping to move?</div>
						<div class="col-12 row calc-right-buttons-wrapper">
							<MultiplyChoiceButton
								buttonText="As soon as possible"
							>
							<input type="radio" v-model="calcReason2" value="As soon as possible">
							</MultiplyChoiceButton>
							<MultiplyChoiceButton
								buttonText="In the next 3 months"
							>
							<input type="radio" v-model="calcReason2" value="In the next 3 months">
							</MultiplyChoiceButton>
							<MultiplyChoiceButton
								buttonText="6-12 months from now"
							>
							<input type="radio" v-model="calcReason2" value="6-12 months from now">
							</MultiplyChoiceButton>
							<MultiplyChoiceButton
								buttonText="12+ months from now"
							>
							<input type="radio" v-model="calcReason2" value="12+ months from now">
							</MultiplyChoiceButton>
							</div>
						</div>
					
						

						<div class="step-nav-buttons mt-4 text-center">
						<button
							type="button"
							class="btn next-step"
							@click="nextStep"
							v-if="currentStep != totalSteps - 1 && currentStep != 72"
							:disabled="!isStepValid"
						>
							Continue
						</button>

						<button
							type="button"
							class="btn calculate"
							v-if="currentStep === totalSteps - 1"
							@click="calculate"
							:disabled="!isStepValid"
						>
							Calculate
						</button>
						</div>

					</div>

					<div v-if="currentStep === 72" ref="resultsContainer">

						<ResultsContainer class="mt-5 mb-5 calc-results-box">
						<div class="mb-3 results-title">Your estimated maximum borrowing amount is: approximately</div>
						<span class="fcs-price">£{{ formatNumberOutput(this.amountAvailable) }}</span>
						</ResultsContainer>

						<SubmissionForm :calculatorName="calculatorName" :calculatorData="collateMessageBody"/>

					</div>

					
				</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BooleanChoiceButtons from '@/components/utilities/booleanChoiceButtons.vue'
import InputElement from '@/components/utilities/inputElement.vue'
import InputTypeNumber from '@/components/utilities/inputTypeNumber.vue'
import MultiplyChoiceButton from '@/components/utilities/multiplyChoiceButton.vue'
import ResultsContainer from '@/components/utilities/resultsContainer.vue'
import SubmissionForm from '@/components/utilities/submissionForm.vue'
import axios from "axios"

export default {
  components: {
    BooleanChoiceButtons,
		InputElement,
		InputTypeNumber,
		MultiplyChoiceButton,
		ResultsContainer,
		SubmissionForm
  },
  data() {
    return {
      currentStep: 1,
			totalSteps: 72,
      calculatorName: 'self-employed-calculator',

      startOption: "",
      propertyOption: "",

      //Purchase
      purchasePrice: 0,
      purchaseValue: 0,
      mortgageAmount: 0,

      //Remortgage
      approximateValue: 0,
      outstandingMortgage: null,
      currentLender: '',
      additionalBorrowing: 0,
      additionalBorrowAmount: 0,

      //Applicants section
      applicantsCount: 0,

      applicantEmployment1: '',

      soleTraderYearsTrading1: '',
      soleTraderAccoutantOption1: '',
      soleTraderTaxReturns1: '',
      soleTraderprofitChange1: '',
      soleTraderLatestProfit1: null,

      partnershipYearsTrading1: '',
      partnershipAccoutantOption1: '',
      partnershipTaxReturns1: '',
      partnershipProfitChange1: '',
      partnershipShareholdPercentage1: 0,
      partnershipShareholdProfit1: null,

      directorYearsTrading1: '',
      directorAccoutantOption1: '',
      directorTaxReturns1: '',
      directorTradingStyle1: '',
      directorSalaryDrawn1: 0,
      directorYearDividends1: null,

      contractorMonths1: '',
      contractorYearsTrading1: '',
      contractorAccountantOption1: '',
      contractorTaxReturns1: '',
      contractorDailyRate1: null,

      subcontractorMonths1: '',
      subcontractorYearsTrading1: '',
      subcontractorSameContractor1: '',
      subcontractorPaymentOfTax1: '',
      subcontractorAnnualIcome1: null,

      employedAnnualIncome1: 0,

      applicantEmployment2: '',

      soleTraderYearsTrading2: '',
      soleTraderAccoutantOption2: '',
      soleTraderTaxReturns2: '',
      soleTraderprofitChange2: '',
      soleTraderLatestProfit2: null,

      partnershipYearsTrading2: '',
      partnershipAccoutantOption2: '',
      partnershipTaxReturns2: '',
      partnershipProfitChange2: '',
      partnershipShareholdPercentage2: 0,
      partnershipShareholdProfit2: null,

      directorYearsTrading2: '',
      directorAccoutantOption2: '',
      directorTaxReturns2: '',
      directorTradingStyle2: '',
      directorSalaryDrawn2: 0,
      directorYearDividends2: null,

      contractorMonths2: '',
      contractorYearsTrading2: '',
      contractorAccountantOption2: '',
      contractorTaxReturns2: '',
      contractorDailyRate2: null,

      subcontractorMonths2: '',
      subcontractorYearsTrading2: '',
      subcontractorSameContractor2: '',
      subcontractorPaymentOfTax2: '',
      subcontractorAnnualIcome2: null,

      employedAnnualIncome2: 0,

      amountAvailable: 0,
      calcCompleted: false,
      calculatorReasonTitle: null,
      calculatorReasonResults: null,
      calculatorListResults: null,
      calcReason1: "",
      calcReason2: "",
      listName: "",
      emailAddress: "",
      consent: "",
      

      submissionReason: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      submissionList: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      formErrors: [],
      gfid: 6, //Please check the Gravity Form for corresponding form id (staging and live may vary!)
      gfidlist: 9 //Please check the Gravity Form for corresponding form id (staging and live may vary!)
    }
  },
  methods: {
    calculate() {
      if (this.currentStep < this.totalSteps) {
				this.currentStep++;
			}
      this.amountAvailable = parseInt(this.calculateQuote)
      this.calcCompleted = true;
      this.calculatorReasonTitle = this.removeHyphensToUpperCase(this.calculatorName);
      this.calculatorReasonResults = 
      `
      Why are you using the calculator today: ${this.calcReason1}
      When will you be ready to move forward: ${this.calcReason2}
      `;
      this.calculatorListName = this.listName;
      this.calculatorEmailAddress = this.emailAddress;
      this.calculatorConsent = this.consent;
      this.$nextTick(() => {
                const resultsContainer = this.$refs.resultsContainer;

                if (resultsContainer) {
                    // Get the bounding rectangle of the element
                    const rect = resultsContainer.getBoundingClientRect();

                    // Calculate the target scroll position
                    const targetScrollPosition = window.scrollY + rect.top - 200;

                    // Scroll to the target position
                    window.scrollTo({
                        top: targetScrollPosition,
                        behavior: 'smooth'
                    });
                } else {
                    console.error('resultsContainer is undefined');
                }
            });
            var newReasonSubmission = new FormData();
            var newListSubmission = new FormData();

      newReasonSubmission.append("form_id", this.gfid); //Please check the Gravity Form form id (staging and live may vary!)
      newReasonSubmission.append("input_1", this.calculatorReasonTitle);
      newReasonSubmission.append("input_3", this.calculatorReasonResults);

      newListSubmission.append("form_id", this.gfidlist); //Please check the Gravity Form form id (staging and live may vary!)
      newListSubmission.append("input_1", this.calculatorListName);
      newListSubmission.append("input_3", this.calculatorEmailAddress);
      newListSubmission.append("input_4.1", this.calculatorConsent ? 1 : 0);

      this.postReasonSubmission(newReasonSubmission);
      this.postListSubmission(newListSubmission);
    },
    async postReasonSubmission(submissionReasonData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/8/submissions', submissionReasonData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionReason = response;
        
        this.submissionReason.is_valid = submissionReason.is_valid;
        this.submissionReason.confirmation_message = submissionReason.confirmation_message;
        this.submissionReason.validation_messages = submissionReason.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    async postListSubmission(submissionListData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/9/submissions', submissionListData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionList = response;
        
        this.submissionList.is_valid = submissionList.is_valid;
        this.submissionList.confirmation_message = submissionList.confirmation_message;
        this.submissionList.validation_messages = submissionList.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    formatNumberOutput(number) {
      const newNumber = (new Intl.NumberFormat('en-GB').format(number))
      if ( newNumber === 'NaN' ) { return 0 } return newNumber
    },
    removeHyphensToUpperCase(str) {
      return str.replace(/(-|^)([^-]?)/g, function(_, prep, letter) { return (prep && ' ') + letter.toUpperCase(); });
    },
    clearPurchasePrice() {
      this.purchasePrice = 0,
          this.mortgageAmount = 0
    },
    clearPurchaseValue() {
      this.purchaseValue = 0,
          this.mortgageAmount = 0
    },
    clearPurchasingValues() {
      this.purchasePrice = 0,
          this.purchaseValue = 0,
          this.mortgageAmount = 0
    },
    clearRemortgagingValues() {
      this.approximateValue =  0,
          this.outstandingMortgage = null,
          this.currentLender = '',
          this.additionalBorrowing =  0,
          this.additionalBorrowAmount = 0
    },
    clearApplicantEmployment1() {
      this.soleTraderYearsTrading1 = '',
          this.soleTraderAccoutantOption1 = '',
          this.soleTraderTaxReturns1 = '',
          this.soleTraderprofitChange1 = '',
          this.soleTraderLatestProfit1 = null,

          this.partnershipYearsTrading1 = '',
          this.partnershipAccoutantOption = '',
          this.partnershipTaxReturns1 = '',
          this.partnershipProfitChange1 = '',
          this.partnershipShareholdPercentage1 = 0,
          this.partnershipShareholdProfit1 = null,

          this.directorYearsTrading1 = '',
          this.directorAccoutantOption1 = '',
          this.directorTaxReturns1 = '',
          this.directorTradingStyle1 = '',
          this.directorSalaryDrawn1 = 0,
          this.directorYearDividends1 = null,

          this.contractorMonths1 = '',
          this.contractorYearsTrading1 = '',
          this.contractorAccountantOption1 = '',
          this.contractorTaxReturns1 = '',
          this.contractorDailyRate1 = null,

          this.subcontractorMonths1 = '',
          this.subcontractorYearsTrading1 = '',
          this.subcontractorSameContractor1 = '',
          this.subcontractorPaymentOfTax1 = '',
          this.subcontractorAnnualIcome1 = null,

          this.employedAnnualIncome1 = 0
    },
    clearApplicantEmployment2() {
      this.soleTraderYearsTrading2 = '',
          this.soleTraderAccoutantOption2 = '',
          this.soleTraderTaxReturns2 = '',
          this.soleTraderprofitChange2 = '',
          this.soleTraderLatestProfit2 = null,

          this.partnershipYearsTrading2 = '',
          this.partnershipAccoutantOption = '',
          this.partnershipTaxReturns2 = '',
          this.partnershipProfitChange2 = '',
          this.partnershipShareholdPercentage2 = 0,
          this.partnershipShareholdProfit2 = null,

          this.directorYearsTrading2 = '',
          this.directorAccoutantOption2 = '',
          this.directorTaxReturns2 = '',
          this.directorTradingStyle2 = '',
          this.directorSalaryDrawn2 = 0,
          this.directorYearDividends2 = null,

          this.contractorMonths2 = '',
          this.contractorYearsTrading2 = '',
          this.contractorAccountantOption2 = '',
          this.contractorTaxReturns2 = '',
          this.contractorDailyRate2 = null,

          this.subcontractorMonths2 = '',
          this.subcontractorYearsTrading2 = '',
          this.subcontractorSameContractor2 = '',
          this.subcontractorPaymentOfTax2 = '',
          this.subcontractorAnnualIcome2 = null,

          this.employedAnnualIncome2 = 0
    },
    clearApplicant2() {
      this.applicantEmployment2 = ''
      this.clearApplicantEmployment2()
    },
    resetCalculation() {
      this.calcCompleted = false;
    },
    valueToZero(value) {
      if ( !Number.isInteger(value) ) { return 0 } return value
    },
    formatEmptyMessageFields(message){
      return message ? message : 'N/A'
    },
    nextStep() {
			if (this.currentStep === 3 && this.propertyOption === 'Yes') {
				this.currentStep = 5;
			} else if (this.currentStep === 5 && this.propertyOption === 'Yes') {
				this.currentStep = 11;
			} else if (this.currentStep === 2 && this.propertyOption === 'No') {
				this.currentStep = 4;
			} else if (this.currentStep === 5 && this.propertyOption === 'No') {
				this.currentStep = 11;
			} else if (this.currentStep === 1 && this.startOption === 'Remortgaging') {
				this.currentStep = 6;
			} else if (this.currentStep === 9 && this.additionalBorrowing === 'No') {
				this.currentStep = 11;
			} else if (this.currentStep === 17 && this.applicantsCount === '1' && this.applicantEmployment1 === 'sole-trader') {
				this.currentStep = 70;
			} else if (this.currentStep === 12 && this.applicantEmployment1 === 'partnership') {
				this.currentStep = 18;
			} else if (this.currentStep === 23 && this.applicantsCount === '1' && this.applicantEmployment1 === 'partnership') {
				this.currentStep = 70;
			} else if (this.currentStep === 12 && this.applicantEmployment1 === 'director-with-shareholding') {
				this.currentStep = 24;
			} else if (this.currentStep === 29 && this.applicantsCount === '1' && this.applicantEmployment1 === 'director-with-shareholding') {
				this.currentStep = 70;
			} else if (this.currentStep === 12 && this.applicantEmployment1 === 'contractor') {
				this.currentStep = 30;
			} else if (this.currentStep === 30 && this.applicantEmployment1 === 'contractor' && this.contractorMonths1 === 'No') {
				this.currentStep = 32;
			} else if (this.currentStep === 34 && this.applicantsCount === '1' && this.applicantEmployment1 === 'contractor') {
				this.currentStep = 70;
			} else if (this.currentStep === 12 && this.applicantEmployment1 === 'cis-worker') {
				this.currentStep = 35;
			} else if (this.currentStep === 35 && this.applicantEmployment1 === 'cis-worker' && this.subcontractorMonths1 === 'No') {
				this.currentStep = 37;
			} else if (this.currentStep === 39 && this.applicantsCount === '1' && this.applicantEmployment1 === 'cis-worker') {
				this.currentStep = 70;
			} else if (this.currentStep === 12 && this.applicantEmployment1 === 'employed') {
				this.currentStep = 40;
			} else if (this.currentStep === 40 && this.applicantsCount === '1' && this.applicantEmployment1 === 'employed') {
				this.currentStep = 70;
			} else if (this.currentStep === 17 && this.applicantsCount === '2' && this.applicantEmployment2 === 'sole-trader') {
				this.currentStep = 41;
			} else if (this.currentStep === 23 && this.applicantsCount === '2' && this.applicantEmployment2 === 'partnership') {
				this.currentStep = 41;
			} else if (this.currentStep === 29 && this.applicantsCount === '2' && this.applicantEmployment2 === 'director-with-shareholding') {
				this.currentStep = 41;
			} else if (this.currentStep === 34 && this.applicantsCount === '2' && this.applicantEmployment2 === 'contractor') {
				this.currentStep = 41;
			} else if (this.currentStep === 39 && this.applicantsCount === '2' && this.applicantEmployment2 === 'cis-worker') {
				this.currentStep = 41;
			} else if (this.currentStep === 40 && this.applicantsCount === '2' && this.applicantEmployment2 === 'employed') {
				this.currentStep = 41;
			} else if (this.currentStep === 46 && this.applicantsCount === '2' && this.applicantEmployment2 === 'sole-trader') {
				this.currentStep = 70;
			} else if (this.currentStep === 41 && this.applicantEmployment2 === 'partnership') {
				this.currentStep = 47;
			} else if (this.currentStep === 52 && this.applicantsCount === '2' && this.applicantEmployment2 === 'partnership') {
				this.currentStep = 70;
			} else if (this.currentStep === 41 && this.applicantEmployment2 === 'director-with-shareholding') {
				this.currentStep = 53;
			} else if (this.currentStep === 58 && this.applicantsCount === '2' && this.applicantEmployment2 === 'director-with-shareholding') {
				this.currentStep = 70;
			} else if (this.currentStep === 41 && this.applicantEmployment2 === 'contractor') {
				this.currentStep = 59;
			} else if (this.currentStep === 59 && this.applicantEmployment2 === 'contractor' && this.contractorMonths2 === 'No') {
				this.currentStep = 61;
			} else if (this.currentStep === 63 && this.applicantsCount === '2' && this.applicantEmployment2 === 'contractor') {
				this.currentStep = 70;
			} else if (this.currentStep === 41 && this.applicantEmployment2 === 'cis-worker') {
				this.currentStep = 64;
			} else if (this.currentStep === 64 && this.applicantEmployment2 === 'cis-worker' && this.subcontractorMonths2 === 'No') {
				this.currentStep = 66;
			} else if (this.currentStep === 68 && this.applicantsCount === '2' && this.applicantEmployment2 === 'cis-worker') {
				this.currentStep = 70;
			} else if (this.currentStep === 41 && this.applicantEmployment2 === 'employed') {
				this.currentStep = 69;
			} else if (this.currentStep === 69 && this.applicantsCount === '2' && this.applicantEmployment2 === 'employed') {
				this.currentStep = 70;
			} else if (this.currentStep < this.totalSteps) {
				this.currentStep++;
			}
		},
		prevStep() {
			if (this.currentStep === 5 && this.propertyOption === 'Yes') {
				this.currentStep = 3;
			} else if (this.currentStep === 11 && this.propertyOption === 'Yes') {
				this.currentStep = 5;
			} else if (this.currentStep === 4 && this.propertyOption === 'No') {
				this.currentStep = 2;
			} else if (this.currentStep === 11 && this.propertyOption === 'No') {
				this.currentStep = 5;
			} else if (this.currentStep === 6 && this.startOption === 'Remortgaging') {
				this.currentStep = 1;
			} else if (this.currentStep === 11 && this.additionalBorrowing === 'No') {
				this.currentStep = 9;
			} else if (this.currentStep === 70 && this.applicantsCount === '1' && this.applicantEmployment1 === 'sole-trader') {
				this.currentStep = 17;
			} else if (this.currentStep === 18 && this.applicantEmployment1 === 'partnership') {
				this.currentStep = 12;
			} else if (this.currentStep === 70 && this.applicantsCount === '1' && this.applicantEmployment1 === 'partnership') {
				this.currentStep = 23;
			} else if (this.currentStep === 24 && this.applicantEmployment1 === 'director-with-shareholding') {
				this.currentStep = 12;
			} else if (this.currentStep === 70 && this.applicantsCount === '1' && this.applicantEmployment1 === 'director-with-shareholding') {
				this.currentStep = 29;
			} else if (this.currentStep === 30 && this.applicantEmployment1 === 'contractor') {
				this.currentStep = 12;
			} else if (this.currentStep === 32 && this.applicantEmployment1 === 'contractor' && this.contractorMonths1 === 'No') {
				this.currentStep = 30;
			} else if (this.currentStep === 70 && this.applicantsCount === '1' && this.applicantEmployment1 === 'contractor') {
				this.currentStep = 34;
			} else if (this.currentStep === 35 && this.applicantEmployment1 === 'cis-worker') {
				this.currentStep = 12;
			} else if (this.currentStep === 37 && this.applicantEmployment1 === 'cis-worker' && this.subcontractorMonths1 === 'No') {
				this.currentStep = 35;
			} else if (this.currentStep === 70 && this.applicantsCount === '1' && this.applicantEmployment1 === 'cis-worker') {
				this.currentStep = 39;
			} else if (this.currentStep === 40 && this.applicantEmployment1 === 'employed') {
				this.currentStep = 12;
			} else if (this.currentStep === 70 && this.applicantsCount === '1' && this.applicantEmployment1 === 'employed') {
				this.currentStep = 40;
			} else if (this.currentStep === 41 && this.applicantsCount === '2' && this.applicantEmployment2 === 'sole-trader') {
				this.currentStep = 17;
			} else if (this.currentStep === 41 && this.applicantsCount === '2' && this.applicantEmployment2 === 'partnership') {
				this.currentStep = 23;
			} else if (this.currentStep === 41 && this.applicantsCount === '2' && this.applicantEmployment2 === 'director-with-shareholding') {
				this.currentStep = 29;
			} else if (this.currentStep === 41 && this.applicantsCount === '2' && this.applicantEmployment2 === 'contractor') {
				this.currentStep = 34;
			} else if (this.currentStep === 41 && this.applicantsCount === '2' && this.applicantEmployment2 === 'cis-worker') {
				this.currentStep = 39;
			} else if (this.currentStep === 41 && this.applicantsCount === '2' && this.applicantEmployment2 === 'employed') {
				this.currentStep = 40;
			} else if (this.currentStep === 70 && this.applicantsCount === '2' && this.applicantEmployment2 === 'sole-trader') {
				this.currentStep = 46;
			} else if (this.currentStep === 47 && this.applicantEmployment2 === 'partnership') {
				this.currentStep = 41;
			} else if (this.currentStep === 70 && this.applicantsCount === '2' && this.applicantEmployment2 === 'partnership') {
				this.currentStep = 52;
			} else if (this.currentStep === 53 && this.applicantEmployment2 === 'director-with-shareholding') {
				this.currentStep = 41;
			} else if (this.currentStep === 70 && this.applicantsCount === '2' && this.applicantEmployment2 === 'director-with-shareholding') {
				this.currentStep = 58;
			} else if (this.currentStep === 59 && this.applicantEmployment2 === 'contractor') {
				this.currentStep = 41;
			} else if (this.currentStep === 61 && this.applicantEmployment2 === 'contractor' && this.contractorMonths2 === 'No') {
				this.currentStep = 59;
			} else if (this.currentStep === 70 && this.applicantsCount === '2' && this.applicantEmployment2 === 'contractor') {
				this.currentStep = 63;
			} else if (this.currentStep === 64 && this.applicantEmployment2 === 'cis-worker') {
				this.currentStep = 41;
			} else if (this.currentStep === 66 && this.applicantEmployment2 === 'cis-worker' && this.subcontractorMonths2 === 'No') {
				this.currentStep = 64;
			} else if (this.currentStep === 70 && this.applicantsCount === '2' && this.applicantEmployment2 === 'cis-worker') {
				this.currentStep = 68;
			} else if (this.currentStep === 69 && this.applicantEmployment2 === 'employed') {
				this.currentStep = 41;
			} else if (this.currentStep === 70 && this.applicantsCount === '2' && this.applicantEmployment2 === 'employed') {
				this.currentStep = 69;
			} else if (this.currentStep === 72) {
				this.currentStep = 71;
			} else if (this.currentStep < this.totalSteps) {
				this.currentStep--;
			}
		},
  },
  computed: {
    /**
     * Check if previous logical section is completed
     * @return {Bool}
     */
    isStepValid() {
			if (this.currentStep === 1) {
				return this.startOption === 'Purchasing' || this.startOption === 'Remortgaging';
			}
			if (this.currentStep === 2) {
				return this.propertyOption === 'Yes' || this.propertyOption === 'No';
			}
			if (this.currentStep === 3) {
				return this.purchasePrice != null;
			}
			if (this.currentStep === 4) {
				return this.purchaseValue != null;
			}
			if (this.currentStep === 5) {
				return this.mortgageAmount != null;
			}
			if (this.currentStep === 6) {
				return this.approximateValue != null;
			}
			if (this.currentStep === 7) {
				return this.outstandingMortgage != null;
			}
			if (this.currentStep === 8) {
				return this.currentLender != null;
			}
			if (this.currentStep === 9) {
				return this.additionalBorrowing === 'Yes' || this.additionalBorrowing === 'No';
			}
			if (this.currentStep === 10) {
				return this.additionalBorrowAmount != null;
			}
			if (this.currentStep === 11) {
				return this.applicantsCount === '1' || this.applicantsCount === '2';
			}
			if (this.currentStep === 12) {
				return this.applicantEmployment1 === 'sole-trader' || this.applicantEmployment1 === 'partnership' || this.applicantEmployment1 === 'director-with-shareholding' || this.applicantEmployment1 === 'contractor' || this.applicantEmployment1 === 'cis-worker' || this.applicantEmployment1 === 'employed';
			}
			if (this.currentStep === 13) {
				return this.soleTraderYearsTrading1 === '0' || this.soleTraderYearsTrading1 === '1' || this.soleTraderYearsTrading1 === '2' || this.soleTraderYearsTrading1 === '3plus';
			}
			if (this.currentStep === 14) {
				return this.soleTraderAccoutantOption1 === 'Yes' || this.soleTraderAccoutantOption1 === 'No';
			}
			if (this.currentStep === 15) {
				return this.soleTraderTaxReturns1 === 'Yes' || this.soleTraderTaxReturns1 === 'No';
			}
			if (this.currentStep === 16) {
				return this.soleTraderprofitChange1 === 'Yes' || this.soleTraderprofitChange1 === 'No';
			}
			if (this.currentStep === 17) {
				return this.soleTraderLatestProfit1 != null;
			}
			if (this.currentStep === 18) {
				return this.partnershipYearsTrading1 === '0' || this.partnershipYearsTrading1 === '1' || this.partnershipYearsTrading1 === '2' || this.partnershipYearsTrading1 === '3plus';
			}
			if (this.currentStep === 19) {
				return this.partnershipAccoutantOption1 === 'Yes' || this.partnershipAccoutantOption1 === 'No';
			}
			if (this.currentStep === 20) {
				return this.partnershipTaxReturns1 === 'Yes' || this.partnershipTaxReturns1 === 'No';
			}
			if (this.currentStep === 21) {
				return this.partnershipProfitChange1 === 'Yes' || this.partnershipProfitChange1 === 'No';
			}
			if (this.currentStep === 22) {
				return this.partnershipShareholdPercentage1 != null;
			}
			if (this.currentStep === 23) {
				return this.partnershipShareholdProfit1 != null;
			}
			if (this.currentStep === 24) {
				return this.directorYearsTrading1 === '0' || this.directorYearsTrading1 === '1' || this.directorYearsTrading1 === '2' || this.directorYearsTrading1 === '3plus';
			}
			if (this.currentStep === 25) {
				return this.directorAccoutantOption1 === 'Yes' || this.directorAccoutantOption1 === 'No';
			}
			if (this.currentStep === 26) {
				return this.directorTaxReturns1 === 'Yes' || this.directorTaxReturns1 === 'No';
			}
			if (this.currentStep === 27) {
				return this.directorTradingStyle1 === 'Yes' || this.directorTradingStyle1 === 'No';
			}
			if (this.currentStep === 28) {
				return this.directorSalaryDrawn1 != null;
			}
			if (this.currentStep === 29) {
				return this.directorYearDividends1 != null;
			}
			if (this.currentStep === 30) {
				return this.contractorMonths1 === 'Yes' || this.contractorMonths1 === 'No';
			}
			if (this.currentStep === 31) {
				return this.contractorYearsTrading1 === '0' || this.contractorYearsTrading1 === '1' || this.contractorYearsTrading1 === '2' || this.contractorYearsTrading1 === '3plus';
			}
			if (this.currentStep === 32) {
				return this.contractorAccountantOption1 === 'Yes' || this.contractorAccountantOption1 === 'No';
			}
			if (this.currentStep === 33) {
				return this.contractorTaxReturns1 === 'Yes' || this.contractorTaxReturns1 === 'No';
			}
			if (this.currentStep === 34) {
				return this.contractorDailyRate1 != null;
			}
			if (this.currentStep === 35) {
				return this.subcontractorMonths1 === 'Yes' || this.subcontractorMonths1 === 'No';
			}
			if (this.currentStep === 36) {
				return this.subcontractorYearsTrading1 === '0' || this.subcontractorYearsTrading1 === '1' || this.subcontractorYearsTrading1 === '2' || this.subcontractorYearsTrading1 === '3plus';
			}
			if (this.currentStep === 37) {
				return this.subcontractorSameContractor1 === 'Yes' || this.subcontractorSameContractor1 === 'No';
			}
			if (this.currentStep === 38) {
				return this.subcontractorPaymentOfTax1 === 'Yes' || this.subcontractorPaymentOfTax1 === 'No';
			}
			if (this.currentStep === 39) {
				return this.subcontractorAnnualIcome1 != null;
			}
			if (this.currentStep === 40) {
				return this.employedAnnualIncome1 != null;
			}
			if (this.currentStep === 41) {
				return this.applicantEmployment2 === 'sole-trader' || this.applicantEmployment2 === 'partnership' || this.applicantEmployment2 === 'director-with-shareholding' || this.applicantEmployment2 === 'contractor' || this.applicantEmployment2 === 'cis-worker' || this.applicantEmployment2 === 'employed';
			}
			if (this.currentStep === 42) {
				return this.soleTraderYearsTrading2 === '0' || this.soleTraderYearsTrading2 === '1' || this.soleTraderYearsTrading2 === '2' || this.soleTraderYearsTrading2 === '3plus';
			}
			if (this.currentStep === 43) {
				return this.soleTraderAccoutantOption2 === 'Yes' || this.soleTraderAccoutantOption2 === 'No';
			}
			if (this.currentStep === 44) {
				return this.soleTraderTaxReturns2 === 'Yes' || this.soleTraderTaxReturns2 === 'No';
			}
			if (this.currentStep === 45) {
				return this.soleTraderprofitChange2 === 'Yes' || this.soleTraderprofitChange2 === 'No';
			}
			if (this.currentStep === 46) {
				return this.soleTraderLatestProfit2 != null;
			}
			if (this.currentStep === 47) {
				return this.partnershipYearsTrading2 === '0' || this.partnershipYearsTrading2 === '1' || this.partnershipYearsTrading2 === '2' || this.partnershipYearsTrading2 === '3plus';
			}
			if (this.currentStep === 48) {
				return this.partnershipAccoutantOption2 === 'Yes' || this.partnershipAccoutantOption2 === 'No';
			}
			if (this.currentStep === 49) {
				return this.partnershipTaxReturns2 === 'Yes' || this.partnershipTaxReturns2 === 'No';
			}
			if (this.currentStep === 50) {
				return this.partnershipProfitChange2 === 'Yes' || this.partnershipProfitChange2 === 'No';
			}
			if (this.currentStep === 51) {
				return this.partnershipShareholdPercentage2 != null;
			}
			if (this.currentStep === 52) {
				return this.partnershipShareholdProfit2 != null;
			}
			if (this.currentStep === 53) {
				return this.directorYearsTrading2 === '0' || this.directorYearsTrading2 === '1' || this.directorYearsTrading2 === '2' || this.directorYearsTrading2 === '3plus';
			}
			if (this.currentStep === 54) {
				return this.directorAccoutantOption2 === 'Yes' || this.directorAccoutantOption2 === 'No';
			}
			if (this.currentStep === 55) {
				return this.directorTaxReturns2 === 'Yes' || this.directorTaxReturns2 === 'No';
			}
			if (this.currentStep === 56) {
				return this.directorTradingStyle2 === 'Yes' || this.directorTradingStyle2 === 'No';
			}
			if (this.currentStep === 57) {
				return this.directorSalaryDrawn2 != null;
			}
			if (this.currentStep === 58) {
				return this.directorYearDividends2 != null;
			}
			if (this.currentStep === 59) {
				return this.contractorMonths2 === 'Yes' || this.contractorMonths2 === 'No';
			}
			if (this.currentStep === 60) {
				return this.contractorYearsTrading2 === '0' || this.contractorYearsTrading2 === '1' || this.contractorYearsTrading2 === '2' || this.contractorYearsTrading2 === '3plus';
			}
			if (this.currentStep === 61) {
				return this.contractorAccountantOption2 === 'Yes' || this.contractorAccountantOption2 === 'No';
			}
			if (this.currentStep === 62) {
				return this.contractorTaxReturns2 === 'Yes' || this.contractorTaxReturns2 === 'No';
			}
			if (this.currentStep === 63) {
				return this.contractorDailyRate2 != null;
			}
			if (this.currentStep === 64) {
				return this.subcontractorMonths2 === 'Yes' || this.subcontractorMonths2 === 'No';
			}
			if (this.currentStep === 65) {
				return this.subcontractorYearsTrading2 === '0' || this.subcontractorYearsTrading2 === '1' || this.subcontractorYearsTrading2 === '2' || this.subcontractorYearsTrading2 === '3plus';
			}
			if (this.currentStep === 66) {
				return this.subcontractorSameContractor2 === 'Yes' || this.subcontractorSameContractor2 === 'No';
			}
			if (this.currentStep === 67) {
				return this.subcontractorPaymentOfTax2 === 'Yes' || this.subcontractorPaymentOfTax2 === 'No';
			}
			if (this.currentStep === 68) {
				return this.subcontractorAnnualIcome2 != null;
			}
			if (this.currentStep === 69) {
				return this.employedAnnualIncome2 != null;
			}
			if (this.currentStep === 70) {
				return this.calcReason1 != null;
			}
			if (this.currentStep === 71) {
				return this.calcReason2 != null;
			}
			return true;
		},
    sectionCompleted() {
      return ( this.mortgageAmount > 0 || this.additionalBorrowing === 'No' || this.additionalBorrowAmount > 0 ) ? true : false
    },
    /**
     * Show button if previous section is completed
     * @return {Bool}
     */
    showListFields() {
			let listFields
      if ( this.applicantsCount < 1 ) { return listFields = false }
      this.applicantsCount == 1
          ? ( this.soleTraderLatestProfit1 || this.partnershipShareholdProfit1 || this.directorYearDividends1 || this.contractorDailyRate1 || this.subcontractorAnnualIcome1 || this.employedAnnualIncome1 ) ? listFields = true : listFields = false
          : ( this.soleTraderLatestProfit2 || this.partnershipShareholdProfit2 || this.directorYearDividends2 || this.contractorDailyRate2 || this.subcontractorAnnualIcome2 || this.employedAnnualIncome2 ) && ( this.soleTraderLatestProfit1 || this.partnershipShareholdProfit1 || this.directorYearDividends1 || this.contractorDailyRate1 || this.subcontractorAnnualIcome1 || this.employedAnnualIncome1 ) ? listFields = true : listFields = false
      return listFields		
		},
    showCalculateButton() {
      let calculateButton
      if ( this.applicantsCount < 1 ) { return calculateButton = false }
      this.applicantsCount == 1
          ? ( this.soleTraderLatestProfit1 || this.partnershipShareholdProfit1 || this.directorYearDividends1 || this.contractorDailyRate1 || this.subcontractorAnnualIcome1 || this.employedAnnualIncome1 ) ? calculateButton = true : calculateButton = false
          : ( this.soleTraderLatestProfit2 || this.partnershipShareholdProfit2 || this.directorYearDividends2 || this.contractorDailyRate2 || this.subcontractorAnnualIcome2 || this.employedAnnualIncome2 ) && ( this.soleTraderLatestProfit1 || this.partnershipShareholdProfit1 || this.directorYearDividends1 || this.contractorDailyRate1 || this.subcontractorAnnualIcome1 || this.employedAnnualIncome1 ) ? calculateButton = true : calculateButton = false
      return calculateButton
    },
    /**
     * Calculate the quote of the available credit
     * @return {Number}
     */
    calculateQuote() {
      return (this.valueToZero(this.soleTraderLatestProfit1) + this.valueToZero(this.partnershipShareholdProfit1) + this.valueToZero(this.directorYearDividends1) + this.valueToZero(this.directorSalaryDrawn1) + this.valueToZero(this.subcontractorAnnualIcome1) + this.valueToZero(this.employedAnnualIncome1) + this.valueToZero(this.soleTraderLatestProfit2) + this.valueToZero(this.partnershipShareholdProfit2) + this.valueToZero(this.directorYearDividends2) + this.valueToZero(this.directorSalaryDrawn2) + this.valueToZero(this.subcontractorAnnualIcome2) + this.valueToZero(this.employedAnnualIncome2) + ((this.valueToZero(this.contractorDailyRate1) * 5) * 48) + ((this.valueToZero(this.contractorDailyRate2) * 5) * 48)) * 5.5
    },
    /**
     * Calculate the total income for the household
     * @return {Number}
     */
    householdIncome() {
      let annualIncome1 = this.valueToZero(this.soleTraderLatestProfit1) + this.valueToZero(this.partnershipShareholdProfit1) + this.valueToZero(this.directorYearDividends1) + this.valueToZero(this.directorSalaryDrawn1) + this.valueToZero(this.contractorDailyRate1) + this.valueToZero(this.subcontractorAnnualIcome1) + this.valueToZero(this.employedAnnualIncome1)
      let annualIncome2 = this.valueToZero(this.soleTraderLatestProfit2) + this.valueToZero(this.partnershipShareholdProfit2) + this.valueToZero(this.directorYearDividends2) + this.valueToZero(this.directorSalaryDrawn2) + this.valueToZero(this.contractorDailyRate2) + this.valueToZero(this.subcontractorAnnualIcome2) + this.valueToZero(this.employedAnnualIncome2)
      return annualIncome1 + annualIncome2;
    },
    collateMessageBody() {
      const calculatorData = {
        calculatorTitle: this.removeHyphensToUpperCase(this.calculatorName),
        calculatorResults:
            `
					Are you purchasing or remortgaging? ${this.startOption}
					Do you have a property in mind? ${this.propertyOption}
					What is the purchase price? £${this.purchasePrice}
					Approximately, what value would you like to purchase at? £${this.purchaseValue}

					What is your required mortgage amount? £${this.mortgageAmount}
					What is the approximate value of your property? £${this.approximateValue}
					What is your current outstanding mortgage amount? £${this.formatEmptyMessageFields( this.outstandingMortgage )}
					Who is your current lender? ${this.currentLender}
					Are you remortgaging with additional borrowing? ${this.additionalBorrowing}
					How much more would you like to borrow? £${this.additionalBorrowAmount}
					
					Number of Applicants? ${this.applicantsCount}

					Applicant1
						Employment status: ${this.formatEmptyMessageFields( this.removeHyphensToUpperCase( this.applicantEmployment1 ) )}

						How long have you been trading? ${this.formatEmptyMessageFields( this.soleTraderYearsTrading1 )}
						Do you have an accountant? ${this.formatEmptyMessageFields( this.soleTraderAccoutantOption1 )}
						Are your tax returns up-to-date? ${this.formatEmptyMessageFields( this.soleTraderTaxReturns1 )}
						Has there been a substantial change in net profit in the last 2 years? ${this.formatEmptyMessageFields( this.soleTraderprofitChange1 )}
						Your latest year's net profit: £${this.formatEmptyMessageFields( this.soleTraderLatestProfit1 )}					

						How long have you been trading? ${this.formatEmptyMessageFields( this.partnershipYearsTrading1 )}
						Do you have an accountant? ${this.formatEmptyMessageFields( this.partnershipAccoutantOption1 )}
						Are your tax returns up-to-date? ${this.formatEmptyMessageFields( this.partnershipTaxReturns1 )}
						Has there been a substantial change in net profit in the last 2 years? ${this.formatEmptyMessageFields( this.partnershipProfitChange1 )}
						What percentage shareholding do you have? ${this.formatEmptyMessageFields( this.partnershipShareholdPercentage1 )}%
						What is your share of the net profit? £${this.formatEmptyMessageFields( this.partnershipShareholdProfit1 )}

						How long have you been a shareholding Director? ${this.formatEmptyMessageFields( this.directorYearsTrading1 )}
						Do you have an accountant? ${this.formatEmptyMessageFields( this.directorAccoutantOption1 )}
						Are your tax returns up-to-date? ${this.formatEmptyMessageFields( this.directorTaxReturns1 )}
						Have you recently changed trading style? ${this.formatEmptyMessageFields( this.directorTradingStyle1 )}
						Your salary drawn: £${this.formatEmptyMessageFields( this.directorSalaryDrawn1 )}
						Dividends for the last 12 months: £${this.formatEmptyMessageFields( this.directorYearDividends1 )}									
						
						Have you been contracting for at least 6 months? ${this.formatEmptyMessageFields( this.contractorMonths1 )}
						If so, how long for? ${this.formatEmptyMessageFields( this.contractorYearsTrading1 )}
						Do you have an accountant? ${this.formatEmptyMessageFields( this.contractorAccountantOption1 )}
						Are you tax returns up to date? ${this.formatEmptyMessageFields( this.contractorTaxReturns1 )}
						What is your daily rate? £${this.formatEmptyMessageFields( this.contractorDailyRate1 )}					
											
						Have you been sub-contracting for at least 12 months? ${this.formatEmptyMessageFields( this.subcontractorMonths1 )}
						If so, how long for? ${this.formatEmptyMessageFields( this.subcontractorYearsTrading1 )}
						Have you worked for the same contractor for 12 months? ${this.formatEmptyMessageFields( this.subcontractorSameContractor1 )}
						Does the company you work for arrange the payment of your tax? ${this.formatEmptyMessageFields( this.subcontractorPaymentOfTax1 )}
						What is your annual income? £${this.formatEmptyMessageFields( this.subcontractorAnnualIcome1 )}
										
						What is your annual income? £${this.formatEmptyMessageFields( this.employedAnnualIncome1 )}
					
					Applicant2
						Employment status: ${this.formatEmptyMessageFields( this.removeHyphensToUpperCase( this.applicantEmployment2 ) )}

						How long have you been trading? ${this.formatEmptyMessageFields( this.soleTraderYearsTrading2 )}
						Do you have an accountant? ${this.formatEmptyMessageFields( this.soleTraderAccoutantOption2 )}
						Are your tax returns up-to-date? ${this.formatEmptyMessageFields( this.soleTraderTaxReturns2 )}
						Has there been a substantial change in net profit in the last 2 years? ${this.formatEmptyMessageFields( this.soleTraderprofitChange2 )}
						Your latest year's net profit: £${this.formatEmptyMessageFields( this.soleTraderLatestProfit2 )}					

						How long have you been trading? ${this.formatEmptyMessageFields( this.partnershipYearsTrading2 )}
						Do you have an accountant? ${this.formatEmptyMessageFields( this.partnershipAccoutantOption2 )}
						Are your tax returns up-to-date? ${this.formatEmptyMessageFields( this.partnershipTaxReturns2 )}
						Has there been a substantial change in net profit in the last 2 years? ${this.formatEmptyMessageFields( this.partnershipProfitChange2 )}
						What percentage shareholding do you have? ${this.formatEmptyMessageFields( this.partnershipShareholdPercentage2 )}%
						What is your share of the net profit? £${this.formatEmptyMessageFields( this.partnershipShareholdProfit2 )}

						How long have you been a shareholding Director? ${this.formatEmptyMessageFields( this.directorYearsTrading2 )}
						Do you have an accountant? ${this.formatEmptyMessageFields( this.directorAccoutantOption2 )}
						Are your tax returns up-to-date? ${this.formatEmptyMessageFields( this.directorTaxReturns2 )}
						Have you recently changed trading style? ${this.formatEmptyMessageFields( this.directorTradingStyle2 )}
						Your salary drawn: £${this.formatEmptyMessageFields( this.directorSalaryDrawn2 )}
						Dividends for the last 12 months: £${this.formatEmptyMessageFields( this.directorYearDividends2 )}									
						
						Have you been contracting for at least 6 months? ${this.formatEmptyMessageFields( this.contractorMonths2 )}
						If so, how long for? ${this.formatEmptyMessageFields( this.contractorYearsTrading2 )}
						Do you have an accountant? ${this.formatEmptyMessageFields( this.contractorAccountantOption2 )}
						Are you tax returns up to date? ${this.formatEmptyMessageFields( this.contractorTaxReturns2 )}
						What is your daily rate? £${this.formatEmptyMessageFields( this.contractorDailyRate2 )}					
											
						Have you been sub-contracting for at least 12 months? ${this.formatEmptyMessageFields( this.subcontractorMonths2 )}
						If so, how long for? ${this.formatEmptyMessageFields( this.subcontractorYearsTrading2 )}
						Have you worked for the same contractor for 12 months? ${this.formatEmptyMessageFields( this.subcontractorSameContractor2 )}
						Does the company you work for arrange the payment of your tax? ${this.formatEmptyMessageFields( this.subcontractorPaymentOfTax2 )}
						What is your annual income? £${this.formatEmptyMessageFields( this.subcontractorAnnualIcome2 )}
										
						What is your annual income? £${this.formatEmptyMessageFields( this.employedAnnualIncome2 )}

            Why are you using the calculator today: ${this.calcReason1}
          When will you be ready to move forward: ${this.calcReason2}
				`
      }

      return calculatorData;
    }
  }
}
</script>

<style lang="scss">
@import './styles/calcs.scss';
</style>